import React, {PropTypes} from 'react'

import AppBar from 'material-ui/AppBar'
import FlatButton from 'material-ui/FlatButton'
import Avatar from 'material-ui/Avatar'

import SignalWifi4Bar from 'material-ui/svg-icons/device/signal-wifi-4-bar'
import SignalWifiOff from 'material-ui/svg-icons/device/signal-wifi-off'
import Brand from '../../assets/images/brand.png'

const Header = ({isStaff, condominium, connected, handleLogout, handleOpenDrawer, handleNavigation}) => {
  return (
    <AppBar
      title={<span>{condominium.name}{' '}{connected ? <SignalWifi4Bar color={'white'} /> : <SignalWifiOff color={'white'} />}</span>}
      titleStyle={{textAlign: 'center'}}
      iconElementRight={<FlatButton label="Sair" />}
      iconElementLeft={<Avatar src={Brand} style={{borderRadius: 0}} backgroundColor="transparent" />}
      onRightIconButtonTouchTap={handleLogout}
    />
  )
}

Header.propTypes = {
  connected: PropTypes.bool.isRequired,
  condominium: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  handleLogout: PropTypes.func.isRequired
}

export default Header



/** WEBPACK FOOTER **
 ** ./src/components/layout/Header.js
 **/